import React, { useEffect, useState } from "react";
import classnames from "classnames";
import moment from "moment";
import Select from "react-select";
import { days } from "../../../Constants/times";
import TimePicker from "../../../components/TimePicker";
import "./BotScheduling.css";
const Styles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 250,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
  }),
};

const BotScheduling = ({ selectedDate,onChangeTime,isVisible }) => {
  const [isrecurring, setIsRecurring] = useState(false);
  const [selectedDay, setSelectedDay] = useState({ value: 0, label: "Sunday" });
  const [time, setStartTime] = useState(null);
  useEffect(()=>{
    onChangeTime(time);
  },[time])
  const handleSelectDay = (selectedDay) => {
    setSelectedDay(selectedDay);
  };
  const handleChangeTime = (time) => {
    const { hh, mm, of } = time;
    let hours = Number(hh);
    let minutes = Number(mm);
    if (of === "pm" && hours < 12) hours = hours + 12;
    if (of === "am" && hours === 12) hours = hours - 12;
    let newtime = moment(selectedDate);
    newtime.set({ hours, minutes });
    setStartTime(newtime);
  };
  return (
    <div className={`${!isVisible?"d-none":''}`}>
      <React.Fragment>
        <p className="add-event-title">Recurring weekly</p>
        <div className="option-container">
          <p className="option-title">
            <React.Fragment>
              <b>Yes</b> or{" "}
            </React.Fragment>
            <b>No</b>
          </p>
          <div className="option-container">
            <div
              className={classnames("check-box", {
                checked: isrecurring,
              })}
              onClick={() => setIsRecurring(true)}
            ></div>
            <div
              className={classnames("check-box", {
                checked: !isrecurring,
              })}
              onClick={() => setIsRecurring(false)}
            ></div>
          </div>
        </div>

        {isrecurring && (
          <React.Fragment>
            <p className="add-event-title">Select day</p>
            <div className="form-group">
              <Select
                value={selectedDay}
                onChange={handleSelectDay}
                options={days}
                styles={Styles}
                placeholder="Day of week"
              />
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
      {selectedDate && (
        <React.Fragment>
          {!isrecurring && (
            <p className="selectedDate-text">{selectedDate.format("LLL")}</p>
          )}
          <TimePicker onChange={handleChangeTime} />
        </React.Fragment>
      )}
    </div>
  );
};
export default BotScheduling;



// WEBPACK FOOTER //
// ./src/screens/AutoConcierge/components/BotScheduling.js